<div class="abdm-records">
  <header class="page-header">
    <div class="page-heading">
      <h2>{{ 'ABDM.TITLE' | translate }}</h2>
      <p>{{ 'ABDM.SUBTITLE' | translate }}</p>
    </div>
    <div class="header-actions">
      <button mat-icon-button type="button" class="refresh-button" [attr.aria-label]="'ABDM.REFRESH_ARIA' | translate"
        [matTooltip]="'ABDM.REFRESH_TITLE' | translate" [disabled]="loading" (click)="refresh()">
        <mat-icon>refresh</mat-icon>
      </button>
      <button mat-flat-button type="button" class="request-button" (click)="requestRecords()">
        <mat-icon>add</mat-icon>
        {{ 'ABDM.REQUEST_RECORDS' | translate }}
      </button>
    </div>
  </header>

  <mat-progress-bar *ngIf="loading" mode="indeterminate"></mat-progress-bar>

  <section class="consent-section" [attr.aria-label]="'ABDM.CONSENT_REQUESTS' | translate">
    <div class="records-toolbar" *ngIf="consents.length">
      <h3>{{ 'ABDM.CONSENT_REQUESTS' | translate }}</h3>
    </div>

    <div class="empty-state" *ngIf="!consents.length && !loading">
      <mat-icon>assignment</mat-icon>
      <span>{{ 'ABDM.NO_CONSENTS' | translate }}</span>
    </div>

    <div class="table-responsive bg-white rounded border" *ngIf="consents.length">
      <table class="table table-hover w-100 m-0">
        <thead>
          <tr>
            <th class="p-3">{{ 'ABDM.PATIENT' | translate }}</th>
            <th class="p-3">{{ 'ABDM.DATA_TYPES_REQUESTED' | translate }}</th>
            <th class="p-3">{{ 'ABDM.VALID_FROM' | translate }}</th>
            <th class="p-3">{{ 'ABDM.VALID_TO' | translate }}</th>
            <th class="p-3">{{ 'ABDM.REQUESTED_ON' | translate }}</th>
            <th class="p-3">{{ 'ABDM.EXPIRES_ON' | translate }}</th>
            <th class="p-3">{{ 'ABDM.STATUS_HEADER' | translate }}</th>
          </tr>
        </thead>
        <tbody>
          <ng-container *ngFor="let consent of consents">
            <tr [class.consent-has-error]="consent.failureReason || (consent.status === 'Granted' && consent.dataFetchFailureReason)">
              <td class="p-3 wrap-cell patient-cell">
                <div class="f-s-13">{{ consent.patientName }}</div>
                <div class="f-s-12 text-muted">{{ consent.abhaAddress }}</div>
              </td>
              <td class="p-3 wrap-cell types-cell">
                <div class="data-type-list" [id]="'consent-types-' + consent.id">
                  <span class="data-type-name" *ngFor="let hiType of visibleHiTypes(consent)">{{ hiTypeLabel(hiType) }}</span>
                </div>
                <button mat-button type="button" class="data-types-toggle" *ngIf="consent.hiTypes.length > 3"
                  [attr.aria-expanded]="expandedConsentTypes.has(consent.id)"
                  [attr.aria-controls]="'consent-types-' + consent.id" (click)="toggleHiTypes(consent.id)">
                  {{ (expandedConsentTypes.has(consent.id) ? 'ABDM.SHOW_LESS_TYPES' : 'ABDM.MORE_TYPES') | translate:{ count: consent.hiTypes.length - 3 } }}
                </button>
              </td>
              <td class="p-3 consent-date-cell">
                <span class="consent-date-value">{{ consent.permissionFrom | date:'dd MMM yyyy' }}</span>
                <span class="consent-time-value">{{ consent.permissionFrom | date:'HH:mm' }}</span>
              </td>
              <td class="p-3 consent-date-cell">
                <span class="consent-date-value">{{ consent.permissionTo | date:'dd MMM yyyy' }}</span>
                <span class="consent-time-value">{{ consent.permissionTo | date:'HH:mm' }}</span>
              </td>
              <td class="p-3 consent-date-cell">
                <span class="consent-date-value">{{ consent.createdOn | date:'dd MMM yyyy' }}</span>
                <span class="consent-time-value">{{ consent.createdOn | date:'HH:mm' }}</span>
              </td>
              <td class="p-3 consent-date-cell">
                <span class="consent-date-value">{{ consent.dataEraseAt | date:'dd MMM yyyy' }}</span>
                <span class="consent-time-value">{{ consent.dataEraseAt | date:'HH:mm' }}</span>
              </td>
              <td class="p-3 status-cell">
                <div class="status-summary">
                  <div class="status-row">
                    <span class="status-label">{{ 'ABDM.CONSENT_STATUS' | translate }}</span>
                    <span class="status-pill m-0" [ngClass]="statusClass(consent.status)">
                      <mat-icon>{{ getStatusIcon(consent.status) }}</mat-icon>
                      {{ statusLabel(consent.status) }}
                    </span>
                  </div>
                  <div class="status-time f-s-11 text-muted" *ngIf="consent.statusChangedOn">
                    {{ consent.statusChangedOn | date:'dd MMM yyyy HH:mm' }}
                  </div>
                  <ng-container *ngIf="consent.status === 'Granted'">
                    <div class="status-row">
                      <span class="status-label">{{ 'ABDM.RECORD_FETCH_STATUS' | translate }}</span>
                      <span class="status-pill fetch-status-pill m-0"
                        [attr.data-fetch-status]="consent.dataFetchStatus"
                        [ngClass]="statusClass(consent.dataFetchStatus)">
                        <mat-icon>{{ getStatusIcon(consent.dataFetchStatus) }}</mat-icon>
                        {{ statusLabel(consent.dataFetchStatus) }}
                      </span>
                    </div>
                  </ng-container>
                  <div class="status-actions">
                  <button mat-button type="button" class="retry-button p-0 min-width-auto btn-sm mt-1"
                    *ngIf="consent.status === 'Failed' && !consent.consentRequestId"
                    [disabled]="isRecovering(consent.id)" (click)="retry(consent)">
                    {{ 'ABDM.RETRY' | translate }}
                  </button>
                  <button mat-button type="button" class="retry-button p-0 min-width-auto btn-sm mt-1"
                    *ngIf="canCheckStatus(consent)" [disabled]="isRecovering(consent.id)"
                    (click)="checkConsentStatus(consent)">
                    {{ 'ABDM.CHECK_STATUS' | translate }}
                  </button>
                  <button mat-stroked-button type="button" class="retry-button record-fetch-retry"
                    *ngIf="canRetryFetch(consent)" [disabled]="isRecovering(consent.id)"
                    (click)="retryFetch(consent)">
                    {{ 'ABDM.RETRY_RECORDS' | translate }}
                  </button>
                  </div>
                </div>
              </td>
            </tr>
            <tr class="consent-error-row"
              *ngIf="consent.failureReason || (consent.status === 'Granted' && consent.dataFetchFailureReason)">
              <td colspan="7">
                <div class="consent-errors">
                  <div class="consent-error" *ngIf="consent.failureReason">
                    <mat-icon aria-hidden="true">error_outline</mat-icon>
                    <div class="consent-error-content">
                      <strong>{{ 'ABDM.CONSENT_STATUS' | translate }}</strong>
                      <p>{{ readableFailureReason(consent.failureReason) }}</p>
                    </div>
                  </div>
                  <div class="consent-error"
                    *ngIf="consent.status === 'Granted' && consent.dataFetchFailureReason">
                    <mat-icon aria-hidden="true">error_outline</mat-icon>
                    <div class="consent-error-content">
                      <strong>{{ 'ABDM.RECORD_FETCH_STATUS' | translate }}</strong>
                      <p>{{ readableFailureReason(consent.dataFetchFailureReason) }}</p>
                    </div>
                  </div>
                </div>
              </td>
            </tr>
          </ng-container>
        </tbody>
      </table>
    </div>
  </section>

  <section class="records-section">
    <div class="records-toolbar">
      <h3>{{ 'ABDM.RECEIVED_RECORDS' | translate }}</h3>
      <div class="records-actions" *ngIf="records.length">
        <label class="search-box">
          <mat-icon>search</mat-icon>
          <input type="search" [value]="searchTerm" (input)="updateSearch($event)"
            [placeholder]="'ABDM.SEARCH_PLACEHOLDER' | translate"
            [attr.aria-label]="'ABDM.SEARCH_PLACEHOLDER' | translate">
        </label>
      </div>
    </div>

    <div class="info-banner" *ngIf="pendingFetch && !loading" role="status">
      <mat-icon>hourglass_top</mat-icon>
      <span>{{ 'ABDM.RECORDS_PENDING' | translate }}</span>
    </div>

    <div class="empty-state" *ngIf="!records.length && !loading && !pendingFetch">
      <mat-icon>folder_open</mat-icon>
      <span>{{ 'ABDM.NO_RECORDS' | translate }}</span>
    </div>
    <div class="empty-state" *ngIf="records.length && !filteredRecords.length">
      <mat-icon>search_off</mat-icon>
      <span>{{ 'ABDM.NO_SEARCH_RESULTS' | translate }}</span>
    </div>

    <div class="records-shell" *ngIf="filteredRecords.length">
      <mat-accordion class="records-list" multi>
        <mat-expansion-panel *ngFor="let record of pagedRecords" (opened)="loadDetails(record)">
          <mat-expansion-panel-header>
            <mat-panel-title>
              <strong>{{ record.title }}</strong>
            </mat-panel-title>
            <mat-panel-description>
              <span>{{ record.hiType }}</span>
              <span class="record-separator">&middot;</span>
              <span>{{ record.sourceHipId }}</span>
              <span class="record-separator">&middot;</span>
              <span>{{ record.recordDate | commonDate }}</span>
            </mat-panel-description>
          </mat-expansion-panel-header>

          <div class="record-loading" *ngIf="!record.fhirJson && !detailLoadFailures.has(record.id)">
            <mat-spinner diameter="20"></mat-spinner>
            {{ 'ABDM.LOADING_DETAILS' | translate }}
          </div>

          <ng-container *ngIf="clinicalViews.get(record.id) as view">
            <div class="record-overview">
              <div class="overview-item" *ngIf="view.patient">
                <div><span>{{ 'ABDM.PATIENT' | translate }}</span><strong>{{ view.patient }} <small
                      *ngIf="view.patientDetails">({{ view.patientDetails }})</small></strong></div>
              </div>
              <div class="overview-item" *ngIf="view.practitioner">
                <div><span>{{ 'ABDM.CLINICIAN' | translate }}</span><strong>{{ view.practitioner }}</strong></div>
              </div>
              <div class="overview-item" *ngIf="view.organization">
                <div><span>{{ 'ABDM.FACILITY' | translate }}</span><strong>{{ view.organization }}</strong></div>
              </div>
              <div class="overview-item">
                <div>
                  <span>{{ 'ABDM.RECORD_DATE' | translate }}</span>
                  <strong>{{ (view.date | commonDate) || ('ABDM.NOT_PROVIDED' | translate) }}</strong>
                </div>
              </div>
            </div>

            <section class="clinical-group" *ngFor="let group of view.groups">
              <h5>{{ group.title }}</h5>
              <div class="clinical-item" *ngFor="let item of group.items">
                <strong>{{ item.label }}</strong>
                <p *ngIf="item.value">{{ item.value }}</p>
                <small *ngIf="item.detail">{{ item.detail }}</small>
              </div>
            </section>

            <section class="clinical-group" *ngIf="view.attachments.length">
              <h5>{{ 'ABDM.ATTACHMENTS' | translate }}</h5>
              <button mat-stroked-button type="button" class="attachment-button"
                *ngFor="let attachment of view.attachments" (click)="openAttachment(attachment)">
                <mat-icon>attach_file</mat-icon>
                {{ attachment.title }}
              </button>
            </section>
          </ng-container>

          <section class="fhir-section" *ngIf="record.fhirJson">
            <button mat-stroked-button type="button" class="fhir-toggle" (click)="toggleFhir(record)">
              <mat-icon>data_object</mat-icon>
              {{ (fhirVisibleRecords.has(record.id) ? 'ABDM.HIDE_FHIR' : 'ABDM.VIEW_FHIR') | translate }}
            </button>
            <pre class="fhir-json" *ngIf="fhirVisibleRecords.has(record.id)">{{ formatFhir(record.fhirJson) }}</pre>
          </section>

          <div class="record-fallback" *ngIf="detailLoadFailures.has(record.id)">
            <p>{{ 'ABDM.DETAIL_LOAD_FAILED' | translate }}</p>
            <p>{{ parseSummary(record.summary) }}</p>
          </div>
        </mat-expansion-panel>
      </mat-accordion>

      <footer class="records-pagination">
        <span>{{ 'ABDM.SHOWING_RECORDS' | translate:{ from: firstVisibleRecord, to: lastVisibleRecord, total:
          filteredRecords.length } }}</span>
        <nav *ngIf="totalPages > 1" [attr.aria-label]="'ABDM.PAGINATION' | translate">
          <button type="button" (click)="goToPage(currentPage - 1)" [disabled]="currentPage === 1"
            [attr.aria-label]="'ABDM.PREVIOUS_PAGE' | translate"><mat-icon>chevron_left</mat-icon></button>
          <button type="button" *ngFor="let page of visiblePages" [class.active]="page === currentPage"
            [attr.aria-current]="page === currentPage ? 'page' : null" (click)="goToPage(page)">{{ page }}</button>
          <button type="button" (click)="goToPage(currentPage + 1)" [disabled]="currentPage === totalPages"
            [attr.aria-label]="'ABDM.NEXT_PAGE' | translate"><mat-icon>chevron_right</mat-icon></button>
        </nav>
      </footer>
    </div>
  </section>
</div>
